var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDraftsDeleteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_delete_forever",
    "data-name": " delete_forever",
    transform: "translate(-236 -242)",
    opacity: 0.853
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Path",
    width: 24,
    height: 24,
    transform: "translate(236 242)",
    fill: "rgba(0,0,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M252,263h-8a2,2,0,0,1-2-2V251a2,2,0,0,1,2-2h8a2,2,0,0,1,2,2v10A2,2,0,0,1,252,263Zm-4-5.59h0l1.419,1.419a1,1,0,1,0,1.41-1.41L249.41,256l1.42-1.419a1,1,0,1,0-1.41-1.41L248,254.59l-1.42-1.42a1,1,0,0,0-1.7.714.973.973,0,0,0,.292.7L246.59,256l-1.42,1.42a1,1,0,1,0,1.41,1.41l1.42-1.419Zm6-9.41H242a1,1,0,1,1,0-2h2.5l.71-.71a1.01,1.01,0,0,1,.7-.29h4.181a1.01,1.01,0,0,1,.7.29l.71.71H254a1,1,0,1,1,0,2Z",
    fill: "#eaa330"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraftsDeleteIcon);
export default __webpack_public_path__ + "static/media/drafts-delete-icon.0dd05dbb6df625f436959f601a188549.svg";
export { ForwardRef as ReactComponent };